import { useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import ApprovedRequests from "./ApprovedRequests";
import PendingRequests from "./PendingRequests";
import RejectedRequests from "./RejectedRequests";


const FrymeTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "pendingRequests";

  useEffect(() => {
    if (!searchParams.get("tab")) {
      searchParams.set("tab", "pendingRequests");
      setSearchParams(searchParams);
    }
  }, []);

  const handleTabChange = (key) => {
    searchParams.set("tab", key);
    setSearchParams(searchParams);
  };

  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <div className="header-container">
        <h1>
          <strong>Frymes</strong>
        </h1>
        {/* <Button onClick={handleBack} variant="info" className="tooltip-btn">
          <IoArrowBackCircleSharp />
          <span className="tooltip-text">Go to Back</span>
        </Button> */}
      </div>

      <Tabs
        activeKey={activeTab}
        onSelect={handleTabChange}
        id="franchiseCustomers"
      >
        <Tab eventKey="pendingRequests" title="Pending Requests">
          <PendingRequests />
        </Tab>

        <Tab eventKey="approvedRequests" title="Approved Requests">
          <ApprovedRequests />
        </Tab>
        <Tab eventKey="rejectedRequests" title="Rejected Requests">
          <RejectedRequests />
        </Tab>
      </Tabs>
    </div>
  );
};

export default FrymeTab;
